import React, { Component } from 'react';
import { instanceOf } from 'prop-types';

import Start from './start'
import Auth from './auth'
import Question from './question_stage3'
// import Question from './question'
import Finish from './finish'
import Winners from './winners'
import Winners2 from './winners2'
import Winners3 from './winners3'
import Rating from './rating'
import queryString from '../../helpers/query-string';
import { withCookies, Cookies } from 'react-cookie';
import { sendEvent } from '../../helpers/analytics'
import axios from 'axios';
import './test.css'

import {BASE_URL} from "../../config";

class Test extends Component {

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  state = {
    currentScreen: 0,
    auth: false,
    score: 0,
    counter: null,
    agree: false,
    time: 0,
    counterInterval: null,
    token: null,
    name: null
  } //

  componentWillMount () {
    const { cookies } = this.props;
    let query = queryString.parse(window.location.search)
    let agree = localStorage.getItem('agree') === 'true'

    this.setState({agree})

    if (query.token) {
      console.log('query', query)
      cookies.set('token', query.token, { path: '/', maxAge: 60 * 24 * 3600 });
    }

    let token = query.token || cookies.get('token') || null

    if (token) {
      this.setState({token})
      let authToken = {'Authorization': 'Bearer ' + token}

      axios({
        url: BASE_URL +'/user/',
        method: 'get',
        headers: authToken
      }).then((res) => {
        console.log(res)
        this.setState({name: res.data.full_name})

      }).catch((err) => {
        console.log(err)
        cookies.remove('token')
        this.setState({token: null, time: 0, name: null })
      })
    }

  }

  componentDidMount () {
    sendEvent('game', 'load', 'about-game')
  }

  startCounter = () => {
    this.setState({counter: 'started'})
    let counterInterval = setInterval(() => {
      let time = this.state.time
      this.setState({time: time += 1})
    },1000)
    this.setState({counterInterval})
  }

  stopCounter = () => {
    clearInterval(this.state.counterInterval);
    this.setState({counterInterval: null, counter: 'stopped'})
  }

  changeCurrentScreen = (i) => {
    this.setState({currentScreen: i})

    if (i === 2 || i === 3 || i === 4 || i === 5) this.stopCounter()
  }

  logUser = () => {
    this.setState({auth: true})
  }

  renderTestScreen = () => {
    const {token, currentScreen, agree} = this.state
    if (currentScreen !== 0 && currentScreen !== 6 && currentScreen !== 5 && currentScreen !== 4 && !token) {
      return <Auth next={this.changeCurrentScreen} login={this.logUser} />
    }

    if (currentScreen === 0) {
      if (agree && token) {
        this.changeCurrentScreen(1)
      }
      return <Start next={this.changeCurrentScreen} />
    } else if (currentScreen === 1) {
      return <Question next={this.changeCurrentScreen} start={() => this.startCounter()} sendScore={(score) => this.setState({score})}  />
    } else if (currentScreen === 2) {
      return <Finish next={this.changeCurrentScreen} time={this.state.time} score={this.state.score} token={this.state.token} />
    } else if (currentScreen === 3) {
      return <Rating token={this.state.token}  />
    } else if (currentScreen === 4) {
      return <Winners  />
    } else if (currentScreen === 5) {
      return <Winners2  />
    } else if (currentScreen === 6) {
      return <Winners3  />
    } else {
      return <Start next={this.changeCurrentScreen} />
    }
  }

  secondsToMinutes (seconds) {
    let minutes = Math.floor(seconds / 60);
    let sec = seconds - minutes * 60;
    let minString = minutes.toString()
    let secString = sec.toString()
    if (minString.length < 2) minString = '0' + minString
    if (secString.length < 2) secString = '0' + secString
    // console.log((minString + secString).split())
    return (minString + secString).split("")
  }

  logout = (e) => {
    const { cookies } = this.props;

    e.preventDefault()
    localStorage.setItem('agree', 'false')
    cookies.remove('token')
    this.stopCounter()
    this.setState({token: null, time: 0, name: null })
    this.changeCurrentScreen(0)
    sendEvent('game', 'click', 'logout')
  }

  render () {
    let { currentScreen, counter, time, name } = this.state
    let counterVal = this.secondsToMinutes(time)

    return (
      <div className={`test__page test__page--${currentScreen}`}>
        <div className="test__pic">
        </div>
        <div className="test__block">
          <nav className="test__nav">
            <div className={"winners__links"}>
              Победители <a onClick={() => {this.changeCurrentScreen(4); sendEvent('game', 'click', 'winners') }}>1-го этапа</a> / <a onClick={() => {this.changeCurrentScreen(5); sendEvent('game', 'click', 'winners') }}>2-го этапа</a> / <a onClick={() => {this.changeCurrentScreen(6); sendEvent('game', 'click', 'winners') }}>3-го этапа</a>
            </div>
            <div>

              <a onClick={() => {this.changeCurrentScreen(3); sendEvent('game', 'click', 'rating-up') }}>Рейтинг участников</a>
              {name ?
                <a onClick={(e) => this.logout(e)} className="no-underline"><span className="underline">{name}</span><img src="/images/cross.svg" className="logout__img" alt=""/></a>
                :
                <a onClick={() => this.changeCurrentScreen(1)}>Авторизоваться</a>
              }
            </div>

          </nav>

          <div className={"test__counter counter--" + counter} >
            <img src="/images/counter.png" alt=""/>
            <img src="/images/counter_green.png" className="counter--green" alt=""/>
            <img src="/images/counter_gray.png" className="counter--gray" alt=""/>

            <div className="counter__digits">
              <div className="counter__inner">
                <div className="digit--1">
                  <img src={`/images/counter/red/${counterVal[0]}.png`} alt=""/>
                </div>
                <div className="digit--2">
                  <img src={`/images/counter/red/${counterVal[1]}.png`} alt=""/>
                </div>
              </div>
              <div className="counter__inner">
                <div className="digit--3">
                  <img src={`/images/counter/green/${counterVal[2]}.png`} alt=""/>
                </div>
                <div className="digit--4">
                  <img src={`/images/counter/green/${counterVal[3]}.png`} alt=""/>
                </div>
              </div>
            </div>
          </div>

          <div className="test__content">
            {this.renderTestScreen()}
          </div>

        </div>
      </div>
    )
  }
}

export default withCookies(Test)


// WEBPACK FOOTER //
// ./src/pages/test/test.js